export const ACCESS_TOKEN = "accessToken";
export const USER_ID = "userId";
export const CURRENT_TRANSFER_ID = "currentTransferId";
export const LOGGED_IN = "loggedIn";
export const DEFAULT_DATE_FORMAT = "MM/dd/yyyy";
export const VENDOR_NAME = "VENDOR_NAME";
export const USER_IDENTITY_ID = "userIdentityId";
